import {
  AfterViewInit,
  Component,
  Directive,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewContainerRef,
  ViewEncapsulation
} from '@angular/core';

import {ToastrService} from 'ngx-toastr';
import {language} from '../../../../language/vn';
import {CommandUtil} from '../../../../global/commandutil';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import {DatePipe} from '@angular/common';
import {Sessioncommand} from '../../../../global/sessioncommand';
import {NavItemService} from '../../../../service/staff/service-navitem';
import {ConfirmDialogComponent} from '../../../dialog/confirmdialog.component';
import {environment} from '../../../../../environments/environment';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import { ThoiHanVanBanDiComponent} from './thoihan.component';
import {TongHopYKienVanBanDiComponent} from './tonghop.component';
import {PdfShowComponent} from '../../view/pdf.component';
import { FileVanBanDiComponent} from './file.component';
import {DanhSachTHVanBanDiComponent} from './danhsach.component';
import {VanBanDiXL} from '../../../../models/vanbandi/vanbandixl';
import {VanBanDiComment} from '../../../../models/vanbandi/vanbandicomment';
import {VanBanDiFile} from '../../../../models/vanbandi/vanbandifile';
import {VanBanDi} from '../../../../models/vanbandi/vanbandi';
import {VanBanDiService} from '../../../../service/vanbandi/service-vanbandi';
import {VanBanDiFileService} from '../../../../service/vanbandi/service-vanbandifile';
import {VanBanDiXLService} from '../../../../service/vanbandi/service-vanbandixl';
import {VanBanDiCommentService} from '../../../../service/vanbandi/service-vanbandicomment';
import {YKienXuLyVanBanDiComponent} from './ykienxuly.component';
import {GXLCap2VanBanDiComponent} from '../giaoxuly/giaoxulycap2.component';
import {GXLCap2VanBanDenComponent} from '../../vanbanden/giaoxuly/giaoxulycap2.component';
import {DomSanitizer} from '@angular/platform-browser';
import {VanBanDenXL} from '../../../../models/vanbanden/vanbandenxl';
@Component({
  selector: 'xulyvanbandi-detail',
  templateUrl: './xulydetail.component.html',
  encapsulation: ViewEncapsulation.None

})
export class XuLyDetailVanBanDiComponent implements OnInit, AfterViewInit {
  @Input() vanBanDiId: number = 0;
  @Output() backMethod: EventEmitter<string> = new EventEmitter();
  @Output() nextPage: EventEmitter<string> = new EventEmitter();
  @Output() backPage: EventEmitter<string> = new EventEmitter();
  public totalItems: number = 0;
  public currentPage: number   = environment.currentPage;
  public maxSize: number = environment.pageMaxRecord;
  public numPages: number = environment.numberPages;
  public id: number = -1;
  public language = language;
  public showAction = true;
  public vanBanDiItem: VanBanDi = new VanBanDi();
  public vanBanDiFiles: VanBanDiFile[] = [];
  public vanBanDiXuLyItem: VanBanDiXL = new VanBanDiXL();
  public ketQuaXuLyNguoiChuTri: String  ="";
  public vanBanDiXuLyList: VanBanDiXL[] = [];
  public vanBanDiCommentList: VanBanDiComment[] = [];
  public submitValidate = false;
  public uploadUrl: String;
  public deleteUrl: String;
  public fileLists: Object[]=[];
  public permissionGXL: boolean = false;
  public permission0048: boolean = false;
  public permission0036: boolean = false;
  public maNguoiXuLy: number = Sessioncommand.staffId;
  public trangThaiHoanThanh: number= environment.hoanthanh;
  public hoanThanhList: VanBanDiXL[] = [];
  public chuaXuLyList: VanBanDiXL[] = [];
  public dangXuLyList: VanBanDiXL[] = [];
  constructor(
    public vanBanDiService: VanBanDiService,
    public toastr: ToastrService,
    public datepipe: DatePipe,
    public commandUtil: CommandUtil,
    public vanBanDiFileService: VanBanDiFileService,
    public vanBanDiXuLyService: VanBanDiXLService,
    public navItemService: NavItemService,
    public bsModalService: BsModalService,
    public vanBanDiCommentService: VanBanDiCommentService,
    public sanitizer: DomSanitizer
  ) {
  }
  ngAfterViewInit() {
  }
  public thoiHan() {
    const modalEdit = this.bsModalService.show(ThoiHanVanBanDiComponent);
    (<ThoiHanVanBanDiComponent>modalEdit.content).edit(
      this.vanBanDiId
    );
    (<ThoiHanVanBanDiComponent>modalEdit.content).onClose.subscribe(result => {
      this.edit(this.vanBanDiId);
    });

  }
  toggleDropdown($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();

  }
  ngOnInit(): void {
    this.navItemService.checkPermissionByCode(Sessioncommand.staffId, '0039', true).subscribe(
      x => {
        this.permissionGXL = x >0? true: false;
        this.edit(this.vanBanDiId);
      }
    );
    this.navItemService.checkPermissionByCode(Sessioncommand.staffId, '0048', true).subscribe(
      x => {
        this.permission0048 = x >0? true: false;
      }
    );
    this.navItemService.checkPermissionByCode(Sessioncommand.staffId, '0036', true).subscribe(
      x => {
        this.permission0036 = x >0? true: false;
      }
    );
  }

  public getVanBanXuLyById(sId: number, s: boolean): string
  {
    let xl: VanBanDiXL = this.vanBanDiXuLyList.find(x => x.maNguoiXuLy === sId);
    return xl == null ? "" : (s === true ?  xl.thoiGianXemLanDau: xl.thoiGianXemLanCuoi);

  }

  public yKienXuLy() {
    const modalEdit = this.bsModalService.show(YKienXuLyVanBanDiComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<YKienXuLyVanBanDiComponent>modalEdit.content).edit(
      this.vanBanDiId
    );
    (<YKienXuLyVanBanDiComponent>modalEdit.content).onClose.subscribe(result => {
      this.edit(this.vanBanDiId);
    });

  }
  showFile(id: number) {
    this.vanBanDiFileService.findAllByVanBanId(id).subscribe( x=>{
      if(x.length>0)
      {
        const modalEdit = this.bsModalService.show(PdfShowComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
        (<PdfShowComponent>modalEdit.content).show(
          this.commandUtil.getUrlDownload(x[0].folder, x[0].fileKey, x[0].width, x[0].name)

        );
        (<PdfShowComponent>modalEdit.content).onClose.subscribe(result => {
          if (result === true) {

          }
        });
      }
    });


  }
  public giaoXuLy() {
    if(this.permission0048) {
      const modalEdit = this.bsModalService.show(GXLCap2VanBanDiComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
      (<GXLCap2VanBanDenComponent>modalEdit.content).edit(
        this.vanBanDiId
      );
      (<GXLCap2VanBanDenComponent>modalEdit.content).onClose.subscribe(result => {
        this.edit(this.vanBanDiId);
      });
    }

  }
  public yKienTongHop() {
    const modalEdit = this.bsModalService.show(TongHopYKienVanBanDiComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<TongHopYKienVanBanDiComponent>modalEdit.content).edit(
      this.vanBanDiId
    );
    (<TongHopYKienVanBanDiComponent>modalEdit.content).onClose.subscribe(result => {
    });

  }
  public thayFile(id: number) {
    const modalEdit = this.bsModalService.show(FileVanBanDiComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<FileVanBanDiComponent>modalEdit.content).edit(
      id
    );
    (<FileVanBanDiComponent>modalEdit.content).onClose.subscribe(result => {
      this.edit(this.vanBanDiId);
    });

  }
  public changeStatus()
  {
    const modal = this.bsModalService.show(ConfirmDialogComponent);
    (<ConfirmDialogComponent>modal.content).showConfirmationModal(
      language.message,
      language.confirm_hoanthanh_question,
      language.yes,
      language.no
    );
    (<ConfirmDialogComponent>modal.content).onClose.subscribe(result => {
      if (result === true) {
        this.vanBanDiXuLyService.changeStatus(this.vanBanDiId, environment.hoanthanh, Sessioncommand.staffId).subscribe(
          {
            next: (data) => {
              if(data !== -1)
              {
                this.toastr.success(language.change_hoanthanh_success, language.message);
                Sessioncommand.vanBanDiStatus = 0;
                Sessioncommand.notification = true;
              }else
                this.toastr.warning(language.error_message_success, language.message);

              this.edit(this.vanBanDiId);
            },
            error: error => {
              this.toastr.error(language.error, language.message);
            }
          }
        );
      }
    });
  }
  public xuLyLai()
  {
    const modal = this.bsModalService.show(ConfirmDialogComponent);
    (<ConfirmDialogComponent>modal.content).showConfirmationModal(
      language.message,
      language.message_xulylai_question,
      language.yes,
      language.no
    );
    (<ConfirmDialogComponent>modal.content).onClose.subscribe(result => {
      if (result === true) {
        this.vanBanDiXuLyService.xuLyLai(this.vanBanDiId, environment.chuaxuly, this.vanBanDiItem.maNguoiChuTri).subscribe(
          {
            next: (data) => {
              this.toastr.success(language.message_xulylai_success, language.message);
              Sessioncommand.vanBanDiStatus = 0;
              Sessioncommand.notification = true;
              this.edit(this.vanBanDiId);
            },
            error: error => {
              this.toastr.error(language.error, language.message);
            }
          }
        );
      }
    });
  }
  public showXuLy(vanBanList: VanBanDiXL[])
  {
    const modalEdit = this.bsModalService.show(DanhSachTHVanBanDiComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<DanhSachTHVanBanDiComponent>modalEdit.content).edit(
      vanBanList
    );
    (<DanhSachTHVanBanDiComponent>modalEdit.content).onClose.subscribe(result => {
    });
  }
  public edit(id: number) {
    this.id = id;
    this.vanBanDiService.getById(id).subscribe(data=> {
      this.vanBanDiItem = data;
      this.vanBanDiXuLyService.getByMaVBAndMCT(id, data.maNguoiChuTri).subscribe(
        data2 => this.ketQuaXuLyNguoiChuTri = data2.ketQua);
    });
    this.vanBanDiXuLyService.getAllByMaVB(id).subscribe( data => {this.vanBanDiXuLyList = data;
      this.hoanThanhList = this.vanBanDiXuLyList.filter( x => x.maTrangThaiXL === environment.hoanthanh);
      this.dangXuLyList = this.vanBanDiXuLyList.filter( x => x.maTrangThaiXL === environment.dangxuly);
      this.chuaXuLyList = this.vanBanDiXuLyList.filter( x => x.maTrangThaiXL === environment.chuaxuly);
    });
    this.loadComment(id);
    this.vanBanDiXuLyService.getByMaVBAndMXL(id, Sessioncommand.staffId).subscribe(
      data => this.vanBanDiXuLyItem = data);
    this.vanBanDiFileService.findAllByVanBanId(id).subscribe(
      x => {
        this.vanBanDiFiles = x;
      });
  }
  public loadComment(id: number)
  {
    this.vanBanDiCommentService.getCountByKeyword(id, Sessioncommand.staffId).subscribe( data => this.totalItems = data);
    this.vanBanDiCommentService.findAllByPaging(id, Sessioncommand.staffId, this.currentPage, this.maxSize).subscribe( data => this.vanBanDiCommentList = data);
  }
  pageChanged(event: any): void {
    this.currentPage = event.page;
    this.loadComment(this.id);
  }


}

